// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"benefit_wrapper__nk8q_","main":"benefit_main__7NhJ5"};